<div class="blade-wrapper">
  <div class="blade-header">
    <div  class="blade-tools">
        <app-toolbar [toolbar]="toolbar">
            <ng-template 
              toolbarToolDef="back_button" let-tool>
              <ng-container  *ngIf="tool.hasButtonsToShow">
              <button mat-button
                      data-cy="button"
                      class="datex-button"
                      [disabled]="tool.control.readOnly || tool.control.disabled"
                      [ngStyle]="tool.control.styles.style"
                      [ngClass]="tool.control.styles.classes"
                      [matTooltip]="tool.control.tooltip"
                      (click)="on_back_button_clicked($event)"
                      >
                <div class="button-label">
                  <ng-container *ngIf="tool.control.icon === 'datex-default-spinner'; else showIcon">
                    <div class="button-icon">
                      <i data-cy="button-icon" class="datex-default-spinner"></i>
                    </div>
                  </ng-container>
                  <ng-template #showIcon>
                    <div class="button-icon">
                      <i data-cy="button-icon" class="icon {{tool.control.icon}}"></i>
                    </div>
                  </ng-template>
                  <div data-cy="button-label" class="button-text">{{tool.control.label}}</div>
                </div>
              
              </button>
              </ng-container>
            </ng-template>
        </app-toolbar>
    </div>
    <ng-content></ng-content>
  </div>
  <div class="blade-content">
    <div class="datex-form">
      <ng-container *ngIf="initialized ">
        <div [formGroup]="formGroup"
             class="formdata">
                <div data-cy="fieldset-id-tote_picking"
                     *ngIf="!fieldsets.tote_picking.hidden && !fieldsets.tote_picking.removed"
                     class="fieldset-container">
                  <div class="fieldsetsContainer"
                       [ngClass]="{'collapsible': fieldsets.tote_picking.collapsible }">
                    <div *ngIf="!fieldsets.tote_picking.hideTitle"
                         data-cy="fieldset-title"
                         class="fieldsetsTitle"
                         (click)="fieldsets.tote_picking.toggle()">
                      <span class="fieldsetsTitle-text">
                      {{fieldsets.tote_picking.label}}
                      </span>
                      <i data-cy="fieldset-toggle"
                         *ngIf="fieldsets.tote_picking.collapsible"
                         class="icon"
                         [ngClass]="{'icon-ic_fluent_chevron_down_20_filled': !fieldsets.tote_picking.expanded, 'icon-ic_fluent_chevron_up_20_filled': fieldsets.tote_picking.expanded }"></i>
                    </div>
                    <div data-cy="fieldset-group"
                         *ngIf="fieldsets.tote_picking.expanded"
                         class="fieldsetsGroup">
                      <div data-cy="field-id-tote_lookup_code" *ngIf="!fields.tote_lookup_code.hidden && !fields.tote_lookup_code.removed" 
                            class="field-container standard {{fields.tote_lookup_code.invalid ? 'invalid' : ''}} {{fields.tote_lookup_code.control.disabled ? 'field-container-disabled' : ''}}"
                            [ngStyle]="fields.tote_lookup_code.styles.style"
                            [ngClass]="fields.tote_lookup_code.styles.classes">
                        <div *ngIf="fields.tote_lookup_code.label" class="label-container"
                             [matTooltip]="fields.tote_lookup_code.tooltip">
                          <label data-cy="field-label" class="datex-label">{{fields.tote_lookup_code.label}}<span *ngIf="fields.tote_lookup_code.required" class="required-asterisk">*</span>
                          </label>
                        </div>
                        <input data-cy="textBox" formControlName="tote_lookup_code"
                                matInput
                                autocomplete="off"
                                spellcheck="false"
                                class="datex-textbox {{ (fields.tote_lookup_code.control.readOnly || fields.tote_lookup_code.control.disabled) ? 'readonly ' : ''}}"
                                placeholder="{{fields.tote_lookup_code.control.placeholder}}"
                                [ngStyle]="fields.tote_lookup_code.control.styles.style"
                                [ngClass]="fields.tote_lookup_code.control.styles.classes"
                                [matTooltip]="fields.tote_lookup_code.control.tooltip"> 
                        <ng-container *ngIf="fields.tote_lookup_code.invalid">
                          <ng-container *ngFor="let error of fields.tote_lookup_code.errors">
                            <span class="invalid-message">
                              {{error}}
                            </span>
                          </ng-container>
                        </ng-container>
                      </div>            </div>
        
                    <div class="fieldset-details" *ngIf="!fieldsets.tote_picking.expanded">
        
        
                    </div>
                  </div>
                </div>
              </div>
      </ng-container>

    </div>
  </div>
</div>